/*  cart-noti.js — 1 Sept 2026

    ⛔ THIS FILE WAS 0 BYTES. It is loaded unconditionally by layout/theme.liquid
    whenever `settings.show_minicart` is false (it is), and snippets/cart-noti.liquid
    renders markup that dereferences `$store.xCartNoti` WITHOUT a guard:

        x-init="$store.xCartNoti.enable = true"
        x-show="$store.xCartNoti.show"
        :class="$store.xCartNoti.show && 'active'"
        x-for="(item,index) in Object.values(Alpine.store('xCartNoti').listItem)"

    With no store registered, every one of those threw on EVERY page load — four
    uncaught TypeErrors, on every theme going back to "DO NOT TOUCH, SAFE COPY THAT
    WORKS", so this predates all of this week's work. Verified against the CDN:
    /cdn/shop/t/177/assets/cart-noti.js returned HTTP 200 with 0 bytes, and neither
    theme.js nor vendors.js registers xCartNoti anywhere.

    ⛔ DELIBERATELY INERT — `show` stays false and `setItem` does nothing.
    The add-to-cart notification has never appeared on this store, and switching it on
    now would be a visible change nobody asked for. This registers the store so the
    expressions RESOLVE instead of throwing; the shop looks exactly as it does today.
    Every JS caller (product-cart, product-list, re-order, product-bundle,
    frequently-bought-together) already guards with
    `if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable)`, so with
    `enable` starting false none of them change behaviour either.

    To actually turn the notification on later, `setItem(response)` receives the
    /cart/add.js response and should populate `listItem` and set `show = true`.

    Registration follows the house pattern used by share-cart.js / cart-term.js /
    coupon-code.js: the Eurus loadedScript guard, then rAF, then alpine:init.
    window.Eurus.loadedScript is created inline in theme.liquid before this loads.  */

if (!window.Eurus.loadedScript.has('cart-noti.js')) {
  window.Eurus.loadedScript.add('cart-noti.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCartNoti', {
        enable: false,
        show: false,
        listItem: {},
        setItem() { /* inert — see header */ }
      });
    });
  });
}
